import React, { Component } from 'react';

class FooterSubscribe extends Component {
  handleFamilyState = event => {
    switch (event.target.value) {
      case 'Themusio':
        window.location.href = 'https://themusio.com';
        break;
      case 'Edge':
        window.location.href = 'https://edge.themusio.com';
        break;
      case 'Intro':
        window.location.href = 'https://edge.themusio.com/intro';
        break;
      default:
    }
  };
  render() {
    return (
      <div className='col-md-4 col-md-offset-4 col-xs-12 text-cetner f_s'>
        <div className='input-group'>
          <select
            id='select'
            name='family_site'
            className='form-control'
            onChange={this.handleFamilyState}
            defaultValue=''
          >
            <option value='' disabled>
              Family Site
            </option>
            <option>Themusio</option>
            <option>Edge</option>
            <option>Intro</option>
          </select>
        </div>
      </div>
    );
  }
}

export default FooterSubscribe;



// WEBPACK FOOTER //
// ./src/components/Footer.subscribe.js